import React from "react";
import "../styles/Screen.css";
const Screen = ({ value }) => <div className="input">{value}</div>;

export default Screen;
